<template lang="">
	<sf-modal-layout :title="getMessage_('SWCC000843')" :show="GuideBoardModal" :closeModal="closeModal" size="L">
		<el-row :gutter="30">
			<el-col :span="4">
				<!-- 버전 -->
				<sf-input-group
					:label="getMessage_('SWCC000330')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="GuideBoardModalValue.ver"
					:onChange="value => setModalValue_({ key: `ver`, value })"
					placeholder="0.0.1"
				/>
			</el-col>
			<el-col :span="6">
				<!-- 구분 -->
				<sf-select-group
					:label="getMessage_('SWCC000844')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="GuideBoardModalValue.category"
					:onChange="value => setModalValue_({ key: 'category', value })"
					:options="categorys"
					:elProps="{ maxlength: 10 }"
				/>
			</el-col>
			<el-col :span="9">
				<!-- 싱세구분 -->
				<sf-input-group
					:label="getMessage_('SWCC000845')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="GuideBoardModalValue.dtlCategory"
					:onChange="value => setModalValue_({ key: 'dtlCategory', value })"
					:elProps="{ maxlength: 10 }"
					placeholder="보안, Vue(UI), 메뉴 등"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 작성자 -->
				<sf-input-group
					:label="getMessage_('SWCC000848')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="GuideBoardModalValue.regId"
					:onChange="value => setModalValue_({ key: `regId`, value })"
					:elProps="{ maxlength: 5 }"
					placeholder="OOO"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="30">
			<el-col :span="24">
				<!-- 제목 -->
				<sf-input-group
					:label="getMessage_('SWCC000519')"
					:inputValue="GuideBoardModalValue.title"
					:onChange="value => setModalValue_({ key: 'title', value })"
					:elProps="{ maxlength: 100 }"
				/>
			</el-col>
		</el-row>
		<el-row>
			<!-- 내용 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('SWCC000846')" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24">
							<el-input
								id="lineHeight"
								type="textarea"
								v-model="GuideBoardModalValue.conts"
								maxlength="4000"
								:rows="10"
								show-word-limit
								@change="value => setModalValue_({ key: 'conts', value })"
							/>
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-upload
					class="upload-demo"
					action=""
					:auto-upload="false"
					:multiple="true"
					:limit="30"
					:on-change="GeneralFileUploadChange"
					:on-remove="handleUploadRemove"
					:file-list="GuideBoardModalValue.fileList"
				>
					<sf-button slot="trigger" v-if="isButton_(scrId, 'AD')" icon="file">Select File</sf-button>
				</el-upload>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000113') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && GuideBoardModalValue.flg == 'U'" :onClick="saveAction">{{
				getMessage_('SWCC000279')
			}}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && GuideBoardModalValue.flg == 'I'" :onClick="addAction">{{
				getMessage_('SWCC000007')
			}}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/GuideBoard/store/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,

		schema() {
			return yup.object().shape({
				ver: yup
					.string()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000330')])) //{0}은(는) 팔수 입력 값 입니다.
					.matches(/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{1,2}$/, this.getMessage_('SWCC000949')), // 버전 양식에 맞게 작성해주세요.
				title: yup.string().required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000519')])), //{0}은(는) 팔수 입력 값 입니다.
				category: yup.string().required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000844')])), //{0}은(는) 팔수 입력 값 입니다.
				dtlCategory: yup.string().required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000845')])) //{0}은(는) 팔수 입력 값 입니다.
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		GeneralFileUploadChange(oneFile, fileList) {
			//console.log('fileList', fileList);
			this.setModalValue_({ key: 'fileList', value: fileList });
		},

		handleUploadRemove(oneFile, fileList) {
			//oneFile: 변경된 파일  fileList: 전체 파일리스트
			//this.fileList = fileList;
			let dl = this.GuideBoardModalValue.delList;
			dl += oneFile.name + '|';
			this.setModalValue_({ key: 'fileList', value: fileList });
			this.setModalValue_({ key: 'delList', value: dl });
			// if (this.fileList == null) {
			// 	//this.fileList = [];
			// 	this.setModalValue_({ key: 'fileList', value: [] });
			// }
		},

		addAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.GuideBoardModalValue);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('SWCC000503'), //추가하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000007'), clickFn: () => this.add() }] //추가
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		add() {
			const formData = new FormData();

			this.$sf_toggleLoading(true);
			Object.keys(this.GuideBoardModalValue).forEach(key => formData.append(key, this.GuideBoardModalValue[key]));
			if (this.GuideBoardModalValue.fileList.length > 0)
				this.GuideBoardModalValue.fileList.forEach(element => formData.append('fileList', element.raw));
			else formData.append('fileList', '');

			this.addGuide_({ formData })
				.then(response => {
					if (response.code == 0) {
						this.$sf_toast({
							type: 'ok',
							message: this.getMessage_('SWCC000534')
						});
						this.getGuideBoardList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
						this.closeModal();
					} else {
						this.$sf_toast({ type: 'error', message: response.message });
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		saveAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.GuideBoardModalValue);

				if (!this.GuideBoardModalValue.boardNo)
					this.$sf_toast({
						type: 'error',
						message: this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000360')])
					});

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('SWCC000553'), //수정하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000279'), clickFn: () => this.save() }] //수정
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		save() {
			const formData = new FormData();
			this.$sf_toggleLoading(true);
			Object.keys(this.GuideBoardModalValue).forEach(key => formData.append(key, this.GuideBoardModalValue[key]));

			if (this.GuideBoardModalValue.fileList.length > 0)
				this.GuideBoardModalValue.fileList.forEach(element => {
					formData.append('fileList', element.raw);
				});
			else formData.append('fileList', '');

			this.saveGuide_({ formData })
				.then(response => {
					if (response.code == 0) {
						this.$sf_toast({
							type: 'ok',
							message: this.getMessage_('SWCC000534')
						});
						this.getGuideBoardList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
						this.closeModal();
					} else {
						this.$sf_toast({ type: 'error', message: response.message });
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		closeModal() {
			this.closeModal_();
		}
	}
};
</script>
<style lang=""></style>
